// extracted by mini-css-extract-plugin
module.exports = {"favorite":"term-deposit_favorite_16DNw","active":"term-deposit_active_14n7s"};